import { FC } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import { Button, Flex, Table } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import { columns } from './constants/columns'
import FiltersForm from './components/filters-form/filters-form'
import FormModal from '../../../components/form-modal/form-modal'
import ReceiptForm from './components/receipt-form/receipt-form'
import { useGetReceiptPositionsQuery } from '../../../store/api/receipt-positions-api'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../../hooks/table-pages/use-endpoint-query-parameters'
import qs from 'qs'
import FormValues from './components/filters-form/types/form-values'
import { EndpointQueryParameters, Filters } from '../../../types/strapi/strapi'
import getBetweenByOneDate from '../../../helpers/filters/get-between-by-one-date'
import useTablePagination from '../../../hooks/table-pages/use-table-pagination'

const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    const { createdAt, materialTypes, width, createdBy } = formValues

    const filters: Filters = {
        material: {
            width: { $eq: width },
            material_type: { documentId: { $eq: materialTypes } },
        },
    }

    if (createdAt) filters.createdAt = getBetweenByOneDate(createdAt)
    if (createdBy) filters.createdBy = { documentId: { $eq: createdBy } }

    return filters
}

const otherParams: EndpointQueryParameters = {
    sort: ['createdAt:desc'],
    populate: {
        receipt: true,
        material: { populate: '*' },
        // createdBy: true,
    },
}

interface MaterialsPageOldProps {}

const MaterialsPageOld: FC<MaterialsPageOldProps> = () => {
    const params = useEndpointQueryParams({ deserializeFilters })
    const { data, refetch } = useGetReceiptPositionsQuery({ ...params, ...otherParams })
    const pagination = useTablePagination(params, data)

    return (
        <PageLayout title={'Приход материала'}>
            <Flex style={{ flex: '0 0 auto' }} justify={'end'}>
                <FormModal
                    width={1500}
                    renderOpener={open => (
                        <Button type={'primary'} icon={<PlusOutlined />} onClick={open}>
                            Принять материал
                        </Button>
                    )}
                    renderContent={close => (
                        <ReceiptForm
                            onSuccess={() => {
                                close()
                                refetch()
                            }}
                        />
                    )}
                />
            </Flex>

            <TableWrapper style={{ flex: 'auto' }}>
                <Table
                    columns={columns}
                    dataSource={data?.data || []}
                    rowKey={r => r.id}
                    pagination={pagination}
                    summary={() => (
                        <Table.Summary fixed={'top'}>
                            <Table.Summary.Row>
                                <FiltersForm />
                            </Table.Summary.Row>
                        </Table.Summary>
                    )}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default MaterialsPageOld
